export default __webpack_public_path__ + "static/am-65c5673902f510e93f6cbb3c377bdea8.jpg";